<template>
  <v-container nowrap grid-list-md>
    <v-flex xs12 class="px-0">
      <span class="font-weight-bold">Dados da Venda</span>
    </v-flex>
    <v-layout wrap>
      <v-flex xs12 sm6 md3>
        <v-select
          :items="payment_type_items"
          item-value="value"
          item-text="text"
          label="Metodo de Pagamento*"
          v-model="payment_type"
          :rules="[(v) => !!v || 'Por favor, informe o método de pagamento']"
          required
        ></v-select>
      </v-flex>
      <v-flex xs12 sm6 md3 v-if="canChooseUniqueBilling && isCemig">
        <v-radio-group
          v-model="unique_billing"
          :disabled="payment_type === 'pix'"
          column
        >
          <v-radio label="Conta única" :value="true"></v-radio>
          <v-radio label="Contas separadas" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex xs12 sm6 md3 v-if="permissions.choose_seller_in_sale">
        <v-autocomplete
          :items="sellers"
          item-text="email"
          return-object
          label="Vendedor"
          v-model="seller"
          :rules="[(v) => !!v || 'Por favor, informe o vendedor']"
          required
        >
        </v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3 v-else>
        <v-select
          :items="['Chat', 'Telefone', 'Representante Comercial']"
          label="Meio da Inscrição"
          v-model="signedcontract_by"
          :rules="[
            (v) =>
              !!v ||
              'Por favor, informe se a inscrição está ocorrendo por telefone ou chat',
          ]"
          required
          :readonly="isSalesPartner"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-select
          :items="enercred_contract_items"
          item-value="value"
          item-text="text"
          label="Gerar contrato da Juntos?"
          v-model="enercred_contract"
          :rules="[
            (v) =>
              v !== '' ||
              'Por favor, informe se deve ser gerado contrato da Juntos Energia',
          ]"
          required
          :readonly="!isAdmin && !isSalesManagement"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm6 md3 v-if="canBeIndicated">
        <v-text-field
          v-model="promo_code"
          label="Email de indicador"
          :hint="
            indicator_name
              ? indicator_name
              : 'E-mail do membro que fez a indicação'
          "
          prepend-icon="email"
          name="promo_code"
          :append-outer-icon="indicator_name ? 'check_circle' : ''"
          filled
          rounded
          dense
          ref="promo_code"
          @change="validaEmailIndicador()"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 sm12 md6>
        <v-textarea
          v-model="sales_observation"
          label="Observação"
          placeholder="Observação sobre a venda e contato realizado..."
          rows="1"
          hint="Opcional"
        >
        </v-textarea>
      </v-flex>
      <v-flex xs12 md3>
        <div class="d-flex align-center" style="min-height: 100%">
          <SalesDocumentModal
            ref="salesDocumentModal"
            @updateDocList="updateDocList"
          />
        </div>
      </v-flex>
      <v-flex xs12 md3>
        <div class="d-flex align-center" style="min-height: 100%">
          <EnergyBillModal
            @updateDocList="updateEnergyBillList"
            :email="user.email"
          />
        </div>
      </v-flex>
    </v-layout>
    <v-snackbar
      :color="snack.color"
      :bottom="snack.bottom"
      :top="snack.top"
      :left="snack.left"
      :right="snack.right"
      v-model="snack.snackbar"
      dark
    >
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snack.snackMessage }}</div>
      <v-icon size="16" @click="snack.snackbar = false">
        mdi-close-circle
      </v-icon>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { getUserByEmail } from "../../../services/users";
import EnergyBillModal from "../EnergyBillModal.vue";
import SalesDocumentModal from "../SalesDocumentModal.vue";
import { hasSomeUserGroupMixin } from "../../../mixin/hasSomeUserGroupMixin";

export default {
  name: "SalesDataForm",

  components: { SalesDocumentModal, EnergyBillModal },

  mixins: [hasSomeUserGroupMixin],

  async mounted() {
    this.updateSignedContractBy();
    if (this.permissions?.choose_seller_in_sale) {
      await this.getSellers();
    }
  },

  data: () => ({
    availableFormats: ["jpg", "jpeg", "png", "pdf"],
    indicator_name: null,
    enercred_contract_items: [
      { text: "Sim", value: true },
      { text: "Não", value: false },
    ],
    payment_type_items: [
      { text: "Boleto", value: "boleto" },
      { text: "Pix", value: "pix" },
    ],
    valid: false,
    snack: {
      color: null,
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackMessage: "",
      snackbar: false,
    },
    unique_billing: false,
    isCemig: false,
  }),

  computed: {
    ...mapState("sales", [
      "user",
      "sellers",
      "seller",
      "reSubscription",
      "proposal_validation",
    ]),

    ...mapState(["permissions"]),
    ...mapGetters(["loggedUser"]),

    payment_type: {
      get() {
        return this.$store.state.sales.user?.payment_type;
      },
      set(value) {
        this.$store.commit("sales/setPaymentType", value);
      },
    },
    seller: {
      get() {
        return this.$store.state.sales.seller;
      },
      set(value) {
        this.$store.commit("sales/setSeller", value);
      },
    },
    enercred_contract: {
      get() {
        return this.$store.state.sales.user?.enercred_contract;
      },
      set(value) {
        this.$store.commit("sales/setContract", value);
      },
    },
    promo_code: {
      get() {
        return this.$store.state.sales.user?.promo_code;
      },
      set(value) {
        this.$store.commit("sales/setIndicator", value);
      },
    },
    sales_observation: {
      get() {
        return this.$store.state.sales.user?.sales_observation;
      },
      set(value) {
        this.$store.commit("sales/setSalesObservation", value);
      },
    },
    signedcontract_by: {
      get() {
        return this.$store.state.sales.user?.signedcontract_by;
      },
      set(value) {
        this.$store.commit("sales/setSignedContractBy", value);
      },
    },

    canBeIndicated() {
      const states = [
        "activated",
        "canceled",
        "canceling",
        "interrupted",
        "interrupting",
      ];
      const ucs = this.proposal_validation?.ucs || [];
      for (const uc of ucs) {
        const status = uc?.status;
        if (states.includes(status)) {
          this.$store.commit("sales/setIndicator", null);
          return false;
        }
      }
      return true;
    },
  },

  methods: {
    ...mapActions("sales", ["getSellers"]),
    ...mapMutations("sales", ["setSignedContractBy"]),
    async validaEmailIndicador() {
      let promo_code = this.$store.state.sales.user?.promo_code;
      getUserByEmail(promo_code)
        .then((res) => {
          if (res.size > 0 && res.docs[0].data().name) {
            this.indicator_name = res.docs[0].data().name;
            return true;
          } else {
            this.indicator_name = null;
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.indicator_name = null;
        });
    },

    updateDocList(docs) {
      this.$emit("pickedPhotos", docs);
    },

    updateEnergyBillList(docs) {
      this.$emit("pickIdEnergyPhoto", docs);
    },

    getDocRule() {
      return this.$refs.salesDocumentModal?.getDocRule();
    },

    show_snack(message, color, ...args) {
      this.snack.top = false;
      this.snack.bottom = false;
      this.snack.left = false;
      this.snack.right = false;

      for (const loc of args) {
        this.snack[loc] = true;
      }

      this.snack.color = color;
      this.snack.snackMessage = message;
      this.snack.snackbar = true;
    },

    updateSignedContractBy() {
      const currentUserGroups = this.loggedUser?.group?.toString();
      if (
        currentUserGroups?.indexOf("sales_partner") >= 0 ||
        currentUserGroups?.indexOf("sales_partner_management") >= 0 ||
        this.permissions.choose_seller_in_sale
      ) {
        this.setSignedContractBy("Representante Comercial");
      }
    },

    emitUniqueBilling() {
      this.$emit("updateUniqueBilling", this.unique_billing);
    },
  },

  watch: {
    "user.signedcontract_by"() {
      this.updateSignedContractBy();
    },

    "user.utility_company": {
      handler(value) {
        this.isCemig = value === "cemig";
      },
      immediate: true,
    },

    isCemig: {
      handler(value) {
        if (!value) {
          this.unique_billing = false;
        }
      },
    },

    payment_type: {
      handler(newVal) {
        if (!this.isCemig) {
          this.unique_billing = false;
        } else if (!this.canChooseUniqueBilling && newVal === "boleto") {
          this.unique_billing = true;
        } else {
          this.unique_billing = false;
        }
      },
      immediate: true,
    },

    unique_billing: {
      handler() {
        this.emitUniqueBilling();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.v-input__append-outer .v-icon,
.v-input__prepend-outer .v-icon {
  color: green !important;
}
</style>
